import styled from 'styled-components';

// Styled components for Organization page
export const ForbiddenWrapper = styled.div`
  text-align: center;
  padding: 50px;
`;

